import { Button, Icon, StackView, Text } from '@cronos-labs/tectonic-ui-kit';
import { useRouter } from 'next/router';

import useIsMobile from '@hooks/useIsMobile';
import useSupportedAsset from '@hooks/useSupportedAsset';
import useWalletBalance from '@hooks/useWalletBalance';
import Card from '@components/Card/Card';
import { TOKEN_LISTS_ADDRESS } from '@config/constants';

interface NOXTonicBeforeBoostingProps {
  hasTonic: boolean;
}

const NOXTonicBeforeBoosting = ({ hasTonic }: NOXTonicBeforeBoostingProps) => {
  const isMobile = useIsMobile();
  const { push } = useRouter();

  const handleClick = () => {
    if (hasTonic) {
      push('/tonic');
      return;
    }

    window.open(
      `https://vvs.finance/swap?disableCurrencySelect&inputCurrency=${TOKEN_LISTS_ADDRESS.USDC}&outputCurrency=${TOKEN_LISTS_ADDRESS.TONIC}`,
      '_blank noreferrer noopener'
    );
  };

  return (
    <div className="mt-2 bg-gradient-to-r from-highlightBorderColorFrom to-highlightBorderColorTo p-[1px] mobile:rounded-[5px]">
      <Card padding="small" className="mobile:rounded-[5px]">
        <div className="flex w-full bg-surface mobile:flex-col">
          <StackView direction="vertical" className="w-11/12">
            <div className="flex items-center">
              {' '}
              <Icon.Boost className="text-yellowPrimary" />
              <Text className="ml-2 text-yellowPrimary" variant="heading3">
                Multiply your rewards
              </Text>
            </div>

            <Text variant="default" className="mt-1 mobile:hidden">
              {hasTonic
                ? 'By locking xTONIC in vault and staking NFT, you can boost the current market APY.'
                : 'Earn higher interest or pay lower borrowing fees by locking xTONIC in a vault.'}
              <a
                className="mt-3 ml-1 !bg-surface text-yellow"
                href="https://tectonic.gitbook.io/docs/protocol/tonic-rewards-boost"
                rel="noopener noreferrer"
                target="_blank"
              >
                Learn more
              </a>
            </Text>

            <Text
              variant="default"
              className="mt-1 desktop:hidden tablet:hidden"
            >
              Lock xTONIC in a Vault to boost your net APY!
              <a
                className="ml-1 !bg-surface text-yellow"
                href="https://tectonic.gitbook.io/docs/protocol/tonic-rewards-boost"
                rel="noopener noreferrer"
                target="_blank"
              >
                Learn more
              </a>
            </Text>
          </StackView>

          {isMobile && (
            <div className="mt-1 flex items-center">
              <Icon.Info className="text-rainbowRed" />
              <Text className="ml-2 text-rainbowRed">
                You don’t have any {hasTonic ? 'xTONIC ' : 'TONIC'} yet!
              </Text>
            </div>
          )}

          <Card
            className="border-0 bg-blueElevatedSurface mobile:mt-1"
            padding="small"
          >
            <div className="flex justify-between">
              <div>
                <div className="flex items-center mobile:hidden">
                  <Icon.Info className="text-rainbowRed" />
                  <Text className="ml-2 text-rainbowRed">
                    You don’t have any {hasTonic ? 'xTONIC ' : 'TONIC'} yet!
                  </Text>
                </div>
                <Text className="mobile:w-10/12">
                  {hasTonic
                    ? 'Stake your TONIC to receive xTONIC'
                    : 'Buy TONIC to stake for xTONIC'}
                </Text>
              </div>
              <Button
                size="small"
                className="desktop:w-2/12"
                onClick={handleClick}
              >
                {hasTonic ? 'Stake' : 'Buy'}
              </Button>
            </div>
          </Card>
        </div>
      </Card>
    </div>
  );
};

export default NOXTonicBeforeBoosting;
